@if (ShowVilage()) {
  <div class="add-edit">
<p-button
  label="Add / Edit"
  (onClick)="updateCultivationCropsData()"
  *appHasRole="[3]"
/>
</div>
}
<p-table [value]="cultivationCropsData" class="tab-data-table">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="firstName" class="text-center">
        Sc No <p-sortIcon field="firstName" />
      </th>

      <th pSortableColumn="address" class="text-center">
        Cultivatable Products <p-sortIcon field="address" />
      </th>
      <th pSortableColumn="address" class="text-center">
        Rabi/Karif <p-sortIcon field="address" />
      </th>
      <th pSortableColumn="Amount" class="text-right">
        Area in Acrs <p-sortIcon field="Amount" />
      </th>
      <th>&nbsp;</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-cultivationData>
    <tr>
      <td class="text-center">
        {{ cultivationData.id }}
      </td>

      <td class="text-right">
        {{ getcultivationCropsName(cultivationData.cultivationId) }}
      </td>

      <td class="text-right">
        {{ cultivationData.seasonName }}
      </td>

      <td class="text-right">
        {{ cultivationData.totalAcrs }}
      </td>
      <td>
        <i
          class="pi pi-pencil"
          (click)="editCultivationData(cultivationData)"
          *appHasRole="[3]"
        ></i>
        <i
          class="pi pi-trash"
          (click)="deleteCultivationData(cultivationData)"
          *appHasRole="[3]"
        ></i>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-sidebar
  [(visible)]="cultivationDataVisible"
  position="right"
  [showCloseIcon]="false"
>
  <form
    [formGroup]="cultivationDataForm"
    (ngSubmit)="updateCultivationDataForm()"
    *ngIf="cultivationDataVisible"
  >
    <div class="tab-pop-txt">
      <h4>Add Cultivation Products</h4>
      <i class="pi pi-times" (click)="cultivationDataVisible = false"></i>
    </div>

    <div class="pop-data-set">
      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Cultivation</div>
        <div class="project-detail-set-v mt-2">
          <p-dropdown
            [options]="cultivationCropsLookupData"
            formControlName="cultivationCrop"
            optionLabel="name"
            optionValue="id"
            placeholder="Select Cultivation"
            #cultivationCrop
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Rabi/Karif/All</div>
        <p-dropdown
          [options]="cultivationSeasons"
          formControlName="seasonsAll"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Season"
          #seasonsAll
        />
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">area in Acrs</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            inputId="areainAcrs"
            formControlName="areainAcrs"
            #areainAcrs
          />
        </div>
      </div>
    </div>

    <div class="tab-footer-btns">
      <p-button
        label="Cancel "
        (click)="cultivationDataVisible = false"
        class="cancel-btn"
      />
      <p-button label="Add " type="submit" class="submit-btn" />
    </div>
  </form>
</p-sidebar>
